import { useDispatch, useSelector } from "react-redux";

import { useEffect, useState } from "react";
import $ from "jquery";
import Swal from "sweetalert2";
import { GetAllPR_Nationality } from "../../Redux/Reducers/ReportStage/NationalityDropDown";
import { GetAllPR_TypeOfActivity } from "../../Redux/Reducers/ReportStage/TypeOfActivityDropDown";
import { GetAllPR_AgeGroup } from "../../Redux/Reducers/ReportStage/AgeGroupDropDown";
import { GetAllPR_City } from "../../Redux/Reducers/ReportStage/CityDropdown";
import {
  AddEventsActivitiesNextFlowData,
  GetOneEventsActivitiesNextFlow,
  restValidateEventsActivitiesNextFlow,
  UpdateEventsActivitiesNextFlowData,
  ValidateEventsActivitiesNextFlow,
} from "../../Redux/Reducers/ReportStage/EventsActivitiesNextFlow";
import { setRefreshTable } from "../../Redux/Reducers/VariousVariables";
import LoaderAHSF from "../../Components/LoaderAHSF";
import ButtonAHSF from "../../Components/ButtonAHSF";
import InputAHSF from "../../Components/InputAHSF";
import AllDropDownsAHSF from "../../Components/AllDropDownsAHSF";
import DateInput from "../../Components/DateInput";
import { useParams } from "react-router-dom";
import {
  decryptToken,
  encryptToken,
} from "../../Services/Account/EncryptionParams";

const AddEditEventsActivitiesNextFlow = (props) => {
  const dispatch = useDispatch();
  let { stageGuid } = useParams();

  stageGuid = decryptToken(stageGuid);
  const state = useSelector((state) => {
    return {
      //////////////////////////////////////////////////////////

      OneEventsActivitiesNextFlow:
        state.EventsActivitiesNextFlow.OneEventsActivitiesNextFlow,
      UpdateEventsActivitiesNextFlow:
        state.EventsActivitiesNextFlow.UpdateEventsActivitiesNextFlow,
      EventsActivitiesNextFlowValidate:
        state.EventsActivitiesNextFlow.EventsActivitiesNextFlowValidate,
      loadingOneEventsActivitiesNextFlow:
        state.EventsActivitiesNextFlow.loadingOneEventsActivitiesNextFlow,

      PR_TypeOfActivityDropDown:
        state.PR_TypeOfActivityDropDown.PR_TypeOfActivityDropDown,

      PR_NationalityDropDown:
        state.PR_NationalityDropDown.PR_NationalityDropDown,

      PR_AgeGroupDropDown: state.PR_AgeGroupDropDown.PR_AgeGroupDropDown,

      PR_CityDropDown: state.PR_CityDropDown.PR_CityDropDown,
    };
  });

  console.log(state.OneEventsActivitiesNextFlow, "event");

  // Gender options for dropdown

  // State for the project admin form

  const [EventsActivitiesNextFlowList, setEventsActivitiesNextFlowList] =
    useState({
      pR_EventsActivitiesNextFlowGUID:
        state.OneEventsActivitiesNextFlow?.pR_EventsActivitiesNextFlowGUID,
      activityName: state.OneEventsActivitiesNextFlow?.activityName,
      pR_NationalityId: state.OneEventsActivitiesNextFlow?.pR_NationalityId,
      pR_TypeOfActivityId:
        state.OneEventsActivitiesNextFlow?.pR_TypeOfActivityId,
      durationDays: state.OneEventsActivitiesNextFlow?.durationDays,
      activityStartDate: state.OneEventsActivitiesNextFlow?.activityStartDate,
      activityEndDate: state.OneEventsActivitiesNextFlow?.activityEndDate,
      pR_AgeGroupID: state.OneEventsActivitiesNextFlow?.pR_AgeGroupID,
      pR_CityId: state.OneEventsActivitiesNextFlow?.pR_CityId,
      pR_ReportsStagesGuid: stageGuid,
    });
  console.log(EventsActivitiesNextFlowList.pR_NationalityId, "event");

  // Effect to fetch TypeOfJobOpportunity data

  // Function to update an existing project management team member

  useEffect(() => {
    dispatch(GetAllPR_TypeOfActivity());
  }, []);

  useEffect(() => {
    dispatch(GetAllPR_Nationality());
  }, []);

  useEffect(() => {
    dispatch(GetAllPR_AgeGroup());
  }, []);
  useEffect(() => {
    dispatch(GetAllPR_City());
  }, []);

  const AddEventsActivitiesNextFlow = async () => {
    const validationList = await dispatch(
      ValidateEventsActivitiesNextFlow({
        activityName: EventsActivitiesNextFlowList.activityName,
        pR_NationalityId: EventsActivitiesNextFlowList.pR_NationalityId,
        pR_TypeOfActivityId: EventsActivitiesNextFlowList.pR_TypeOfActivityId,
        durationDays:
          EventsActivitiesNextFlowList.durationDays == ""
            ? null
            : EventsActivitiesNextFlowList.durationDays,
        // durationDays: EventsActivitiesNextFlowList.durationDays,
        activityStartDate: EventsActivitiesNextFlowList.activityStartDate,
        activityEndDate: EventsActivitiesNextFlowList.activityEndDate,
        pR_AgeGroupID: EventsActivitiesNextFlowList.pR_AgeGroupID,
        pR_CityId: EventsActivitiesNextFlowList.pR_CityId,
      })
    );

    if (validationList.payload.length === 0) {
      await dispatch(
        AddEventsActivitiesNextFlowData({
          activityName: EventsActivitiesNextFlowList.activityName,
          pR_NationalityId: EventsActivitiesNextFlowList.pR_NationalityId,
          pR_TypeOfActivityId: EventsActivitiesNextFlowList.pR_TypeOfActivityId,
          activityStartDate: EventsActivitiesNextFlowList.activityStartDate,
          activityEndDate: EventsActivitiesNextFlowList.activityEndDate,
          pR_AgeGroupID: EventsActivitiesNextFlowList.pR_AgeGroupID,
          durationDays: EventsActivitiesNextFlowList.durationDays,
          pR_CityId: EventsActivitiesNextFlowList.pR_CityId,
          pR_ReportsStagesGuid:
            EventsActivitiesNextFlowList.pR_ReportsStagesGuid,
        })
      );
      $(".close-btn").trigger("click");
      Swal.fire({
        position: "center",
        icon: "success",
        title: "تم اضافة المعلومات بنجاح",
        showConfirmButton: false,
        timer: 1500,
        // width: "500px",
      });
      dispatch(setRefreshTable());
    }
  };

  const UpdateEventsActivitiesNextFlow = async () => {
    const validationList = await dispatch(
      ValidateEventsActivitiesNextFlow({
        activityName: EventsActivitiesNextFlowList.activityName,

        pR_NationalityId: EventsActivitiesNextFlowList.pR_NationalityId,
        pR_TypeOfActivityId: EventsActivitiesNextFlowList.pR_TypeOfActivityId,
        durationDays:
          EventsActivitiesNextFlowList.durationDays == ""
            ? null
            : EventsActivitiesNextFlowList.durationDays,
        activityStartDate: EventsActivitiesNextFlowList.activityStartDate,
        activityEndDate: EventsActivitiesNextFlowList.activityEndDate,
        pR_AgeGroupID: EventsActivitiesNextFlowList.pR_AgeGroupID,
        pR_CityId: EventsActivitiesNextFlowList.pR_CityId,
      })
    );
    // If no validation errors, update team member
    if (validationList.payload.length === 0) {
      await dispatch(
        UpdateEventsActivitiesNextFlowData({
          pR_EventsActivitiesNextFlowGUID:
            EventsActivitiesNextFlowList.pR_EventsActivitiesNextFlowGUID,
          activityName: EventsActivitiesNextFlowList.activityName,
          pR_NationalityId: EventsActivitiesNextFlowList.pR_NationalityId,
          pR_TypeOfActivityId: EventsActivitiesNextFlowList.pR_TypeOfActivityId,
          activityStartDate: EventsActivitiesNextFlowList.activityStartDate,
          activityEndDate: EventsActivitiesNextFlowList.activityEndDate,
          durationDays: EventsActivitiesNextFlowList.durationDays,
          pR_AgeGroupID: EventsActivitiesNextFlowList.pR_AgeGroupID,
          pR_CityId: EventsActivitiesNextFlowList.pR_CityId,
          pR_ReportsStagesGuid:
            EventsActivitiesNextFlowList.pR_ReportsStagesGuid,
        })
      );
      $(".close-btn").trigger("click");
      Swal.fire({
        position: "center",
        icon: "success",
        title: "تم تعديل المعلومات بنجاح",
        showConfirmButton: false,
        timer: 1500,
        // width: "500px",
      });
      dispatch(setRefreshTable());
    }
  };
  useEffect(() => {
    dispatch(restValidateEventsActivitiesNextFlow());
  }, []);
  useEffect(() => {
    if (props != null) {
      dispatch(
        GetOneEventsActivitiesNextFlow(props.pR_EventsActivitiesNextFlowGUID)
      );
    }
  }, [props.pR_EventsActivitiesNextFlowGUID]);
  useEffect(() => {
    if (
      !state.loadingOneEventsActivitiesNextFlow &&
      Object.keys(props).length != 0
    ) {
      setEventsActivitiesNextFlowList({
        ...state.OneEventsActivitiesNextFlow,
      });
    } else {
      setEventsActivitiesNextFlowList({
        activityName: null,
        pR_NationalityId: null,
        pR_TypeOfActivityId: null,
        activityStartDate: null,
        activityEndDate: null,
        pR_AgeGroupID: null,
        pR_CityId: null,
        durationDays: null,
        pR_ReportsStagesGuid: EventsActivitiesNextFlowList.pR_ReportsStagesGuid,
      });
    }
  }, [state.OneEventsActivitiesNextFlow]);

  //   const shouldDisableFields = !(

  //     (
  //       state.ActiveRound == state.ApplicationInformation?.aI_RoundYearId &&
  //       state.ApplicationInformation?.aI_ApplicationStatus?.canEdite &&
  //       window.location.href.includes("manager") == false
  //     )
  //   );
  //to render html after loading ends
  return (
    <>
      {!state.loadingOneEventsActivitiesNextFlow ? (
        <>
          <div className="AddEdite">
            <InputAHSF
              fieldsName="ActivityName"
              show={true}
              disabled={props.shouldDisableFields}
              onChange={(e) => {
                setEventsActivitiesNextFlowList({
                  ...EventsActivitiesNextFlowList,
                  activityName: e.target.value,
                });
              }}
              defaultValue={
                state.OneEventsActivitiesNextFlow?.activityName
                // OpportunitiesObtainedList?.entityProvidingOpportunity
              }
              showValidationMessage={
                state.EventsActivitiesNextFlowValidate
                  ? state.EventsActivitiesNextFlowValidate.includes(
                      "ActivityName"
                    )
                  : false
              }
              validationMessage="يرجى تعبئة هذا الحقل"
            />
            {/* <AllDropDownsAHSF
              fieldsName="PR_Nationality"
              show={true}
              // disabled={shouldDisableFields}
              arrayOoptionList={state.PR_NationalityDropDown}
              KeyText={"nationalityAr"}
              KeyValue={"pR_NationalityId"}
              dropdownType={"normal"}
              onChange={(e) => {
                setEventsActivitiesNextFlowList({
                  ...EventsActivitiesNextFlowList,
                  pR_NationalityId: Number(e.target.value),
                });
              }}
              defaultValue={EventsActivitiesNextFlowList.pR_NationalityId}
              showValidationMessage={
                state.EventsActivitiesNextFlowValidate
                  ? state.EventsActivitiesNextFlowValidate.includes(
                      "PR_Nationality"
                    )
                  : false
              }
              validationMessage="يرجى تعبئة هذا الحقل"
            />
            <AllDropDownsAHSF
              fieldsName="PR_CityId"
              show={true}
              // disabled={shouldDisableFields}
              arrayOoptionList={state.PR_CityDropDown}
              KeyText={"cityNAmeAr"}
              KeyValue={"pR_CityId"}
              dropdownType={"normal"}
              onChange={(e) => {
                setEventsActivitiesNextFlowList({
                  ...EventsActivitiesNextFlowList,
                  pR_CityId: Number(e.target.value),
                });
              }}
              defaultValue={EventsActivitiesNextFlowList.pR_CityId}
              showValidationMessage={
                state.EventsActivitiesNextFlowValidate
                  ? state.EventsActivitiesNextFlowValidate.includes("PR_CityId")
                  : false
              }
              validationMessage="يرجى تعبئة هذا الحقل"
            /> */}
            <AllDropDownsAHSF
              fieldsName="PR_Nationality"
              show={true}
              disabled={props.shouldDisableFields}
              arrayOoptionList={state.PR_NationalityDropDown}
              KeyText={"nationalityAr"}
              KeyValue={"pR_NationalityId"}
              dropdownType={"normal"}
              onChange={(e) => {
                const selectedNationalityId = Number(e.target.value);
                setEventsActivitiesNextFlowList({
                  ...EventsActivitiesNextFlowList,
                  pR_NationalityId: selectedNationalityId,
                  // Reset the city if nationality changes
                  pR_CityId: null,
                });
              }}
              defaultValue={EventsActivitiesNextFlowList.pR_NationalityId}
              showValidationMessage={
                state.EventsActivitiesNextFlowValidate
                  ? state.EventsActivitiesNextFlowValidate.includes(
                      "PR_Nationality"
                    )
                  : false
              }
              validationMessage="يرجى تعبئة هذا الحقل"
            />

            <AllDropDownsAHSF
              fieldsName="PR_CityId"
              show={true}
              disabled={props.shouldDisableFields}
              arrayOoptionList={
                EventsActivitiesNextFlowList.pR_NationalityId
                  ? state.PR_CityDropDown.filter(
                      (city) =>
                        city.pR_NationalityId ===
                        EventsActivitiesNextFlowList.pR_NationalityId
                    )
                  : [] // Empty array when no nationality is selected
              }
              KeyText={"cityNAmeAr"}
              KeyValue={"pR_CityId"}
              dropdownType={"normal"}
              onChange={(e) => {
                setEventsActivitiesNextFlowList({
                  ...EventsActivitiesNextFlowList,
                  pR_CityId: Number(e.target.value),
                });
              }}
              defaultValue={EventsActivitiesNextFlowList.pR_CityId}
              showValidationMessage={
                state.EventsActivitiesNextFlowValidate
                  ? state.EventsActivitiesNextFlowValidate.includes("PR_CityId")
                  : false
              }
              validationMessage="يرجى تعبئة هذا الحقل"
            />

            <AllDropDownsAHSF
              fieldsName="PR_TypeOfActivityId"
              show={true}
              disabled={props.shouldDisableFields}
              arrayOoptionList={state.PR_TypeOfActivityDropDown}
              KeyText={"typeOfActivityNAme"}
              KeyValue={"pR_TypeOfActivityId"}
              dropdownType={"normal"}
              onChange={(e) => {
                setEventsActivitiesNextFlowList({
                  ...EventsActivitiesNextFlowList,
                  pR_TypeOfActivityId: Number(e.target.value),
                });
              }}
              defaultValue={EventsActivitiesNextFlowList.pR_TypeOfActivityId}
              showValidationMessage={
                state.EventsActivitiesNextFlowValidate
                  ? state.EventsActivitiesNextFlowValidate.includes(
                      "PR_TypeOfActivityId"
                    )
                  : false
              }
              validationMessage="يرجى تعبئة هذا الحقل"
            />

            <InputAHSF
              fieldsName="DurationDays"
              type={"number"}
              show={true}
              disabled={props.shouldDisableFields}
              onChange={(e) => {
                setEventsActivitiesNextFlowList({
                  ...EventsActivitiesNextFlowList,
                  durationDays: e.target.value,
                });
              }}
              defaultValue={
                state.OneEventsActivitiesNextFlow?.durationDays
                // OpportunitiesObtainedList?.entityProvidingOpportunity
              }
              showValidationMessage={
                state.EventsActivitiesNextFlowValidate
                  ? state.EventsActivitiesNextFlowValidate.includes(
                      "DurationDays"
                    )
                  : false
              }
              validationMessage="يرجى تعبئة هذا الحقل"
            />

            <DateInput
              fieldsName="ActivityStartDate"
              list=""
              date={state.OneEventsActivitiesNextFlow?.activityStartDate}
              onChange={(e) => {
                setEventsActivitiesNextFlowList({
                  ...EventsActivitiesNextFlowList,
                  activityStartDate: e, // التحديث هنا
                });
              }}
              disabled={props.shouldDisableFields}
              showValidationMessage={
                state.EventsActivitiesNextFlowValidate
                  ? state.EventsActivitiesNextFlowValidate.includes(
                      "ActivityStartDate"
                    )
                  : false
              }
              validationMessage="يرجى تعبئة هذا الحقل"
            />
            <DateInput
              fieldsName="ActivityEndDate"
              list=""
              date={state.OneEventsActivitiesNextFlow?.activityEndDate}
              onChange={(e) => {
                setEventsActivitiesNextFlowList({
                  ...EventsActivitiesNextFlowList,
                  activityEndDate: e, // التحديث هنا
                });
              }}
              disabled={props.shouldDisableFields}
              showValidationMessage={
                state.EventsActivitiesNextFlowValidate
                  ? state.EventsActivitiesNextFlowValidate.includes(
                      "ActivityEndDate"
                    )
                  : false
              }
              validationMessage="يرجى تعبئة هذا الحقل"
            />

            <AllDropDownsAHSF
              fieldsName="PR_AgeGroup"
              show={true}
              disabled={props.shouldDisableFields}
              arrayOoptionList={state.PR_AgeGroupDropDown}
              KeyText={"ageGroupName"}
              KeyValue={"pR_AgeGroupID"}
              dropdownType={"normal"}
              onChange={(e) => {
                setEventsActivitiesNextFlowList({
                  ...EventsActivitiesNextFlowList,
                  pR_AgeGroupID: Number(e.target.value),
                });
              }}
              defaultValue={EventsActivitiesNextFlowList.pR_AgeGroupID}
              showValidationMessage={
                state.EventsActivitiesNextFlowValidate
                  ? state.EventsActivitiesNextFlowValidate.includes(
                      "PR_AgeGroup"
                    )
                  : false
              }
              validationMessage="يرجى تعبئة هذا الحقل"
            />
            {!props.shouldDisableFields ? (
            <div className="containersButton">
              <div>
                <ButtonAHSF
                  type={"submitter"}
                  onClick={() => {
                    props.canEdit == "edit"
                      ? UpdateEventsActivitiesNextFlow()
                      : AddEventsActivitiesNextFlow();
                  }}
                  disabled={false}
                  title={Object.keys(props).length == 0 ? "إضافة" : "تعديل"}
                  text={Object.keys(props).length == 0 ? "إضافة" : "تعديل"}
                  show={true}
                />
              </div>
            </div>
             ) : (
              ""
            )} 
          </div>
        </>
      ) : (
        ""
      )}
      <LoaderAHSF show={state.loadingOneEventsActivitiesNextFlow} />
    </>
  );
};

export default AddEditEventsActivitiesNextFlow;
